"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HumanActions = void 0;
var HumanActions;
(function (HumanActions) {
    /**
     * Convert object action to string
     * @param figure Action Dictionary
     */
    function encode(action) {
        return Object.entries(action)
            .filter(([a]) => !action[a] && typeof action[a] !== 'number')
            .map(([key, value]) => value === true ? key : [key, value].join('='))
            .join(',');
    }
    HumanActions.encode = encode;
    /**
     * Convert string to action object
     * @param figure Action String
     */
    function decode(action) {
        return action
            .split(',')
            .map(part => part.split('='))
            .reduce((obj, [key, value = true]) => (Object.assign(Object.assign({}, obj), { [key]: value })), {});
    }
    HumanActions.decode = decode;
})(HumanActions = exports.HumanActions || (exports.HumanActions = {}));
